import Mark from 'mark.js';
import dtm from 'dtm.js';

window.dtm = dtm;

export function populateTableWidthData(data, cheapModel){
    // Main Container for each row
    var tableWrapper = $("#specsGroups");
    var specsRows = "";
    
    // For table Header. First, insert the image.
    //var tableHeaderImages = $("#cars-header-images");
    //$(tableHeaderImages).find('.car-1 > img').attr('src', cheapModel.image)
 
    // For table Header. Second, insert the version and price of the model.
    var tableHeaderVersionName = $("#cars-header-data");
    $( $("#cars-header-data .nav a")[0] ).find("small > .version").text( cheapModel.version)
    if($("body").attr('data-show-price') == 1) {
        $( $("#cars-header-data .nav a")[0] ).find("small > .price").text( cheapModel.formated_price)
    }

    // Iterate over parent category and create a group of field/value for the first model selected.
    for (var category in data) {
        specsRows  += getSpecsGroup( category, data[category], cheapModel);
    }

    // Precharged table could be a solution to responsive Iframe. Empty all initial data and populate with the new one 
    $(tableWrapper).empty().append( specsRows )
}

var rowExceptions = ["CTA"];

// Helpers
var getIcon = (key) => {

    let notAvailableIcon = `
        <svg width="18px" height="18px" viewBox="0 -6 19.71 19.71">
            <path d="M18.07 3.67a1.23 1.23 0 0 1-1.23 1.23H1.24A1.23 1.23 0 0 1 .01 3.67V1.21A1.23 1.23 0 0 1 1.24-.02h15.6a1.23 1.23 0 0 1 1.23 1.23v2.46z">
            </path>
        </svg>
        <span>No Disponible</span>
    `;

    let standarIcon = `
        <svg width="18px" height="18px" viewBox="0 0 19.71 19.71">
            <path d="M9.85 19.72a9.86 9.86 0 1 1 9.86-9.86 9.86 9.86 0 0 1-9.86 9.86zm6.4-12.48l-1.17-1.16a.81.81 0 0 0-1.15 0l-5.27 5.16-2.9-2.9a.81.81 0 0 0-1.15 0L3.44 9.49a.84.84 0 0 0-.23.59.81.81 0 0 0 .23.58l4.65 4.65a.82.82 0 0 0 1.17 0l7-7a.8.8 0 0 0 .23-.58.83.83 0 0 0-.24-.49z">
            </path>
        </svg>
        <span>Estándar</span>
    `;

    let availableIcon = `
        <svg width="18px" height="18px" viewBox="0 0 19.71 19.71">
            <path d="M9.85 19.72a9.86 9.86 0 1 1 9.86-9.86 9.86 9.86 0 0 1-9.86 9.86zm6.4-12.48l-1.17-1.16a.81.81 0 0 0-1.15 0l-5.27 5.16-2.9-2.9a.81.81 0 0 0-1.15 0L3.44 9.49a.84.84 0 0 0-.23.59.81.81 0 0 0 .23.58l4.65 4.65a.82.82 0 0 0 1.17 0l7-7a.8.8 0 0 0 .23-.58.83.83 0 0 0-.24-.49z">
            </path>
        </svg>
        <span>Disponible</span>
    `;

    let StdIcon = `
        <span>STD</span>
    `;

    let icons = [
        { icon: 'standar-icon' ,values:['S'], iconHTML: standarIcon },
        { icon: 'not-available', values:['-','N/A'], iconHTML: notAvailableIcon},
        { icon: 'available', values:['A'], iconHTML: availableIcon},
        { icon: 'STD', values:['STD'], iconHTML: StdIcon}
    ]

    let icon;
    for (let i=0; i < icons.length; i++) {
        icons[i].values.forEach( ( value )=>{
            if( value == key ){
                icon = icons[i].iconHTML;
                return icon;
            }else{
               return false;
            }
        })
    }
    return icon;
  }

/**
 *  Return the html for each group of specs. And populate the version preselected. ( cheapier version )
 */
function getSpecsGroup( category, data, cheapModel ){

    var populateRows = (category )=>{
        
        let rows = "";
        let cols = "";
        
        for(let i = 0; i < carsLength; i++) {
            cols += '<td class="info"></td>';
        }

        data.forEach(element => {
            let specValue = cheapModel[category][element]
            
            if(rowExceptions.indexOf(element) == -1) {
                let icon = getIcon(specValue);
                rows +=`<tbody>
                    <tr>
                        <td class="title">${element}</td>
                        ${cols}
                    </tr>
                </tbody>`
            }
        });
        return rows;
    }

    if(rowExceptions.indexOf(category) > -1) {
        return '';
    }

    return `
        <div class="card">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link collapsed stat-expand-icon" data-dtm="compare versions" type="button" data-toggle="collapse" data-target="#collapse-${ category.replace(/\s+/g, '-') }" aria-controls="collapse-${category.replace(/\s+/g, '-')}">
                        ${category}
                    </button>
                </h2>
            </div>
            <div id="collapse-${category.replace(/\s+/g, '-')}" class="collapse" style="">
                <div class="card-body">
                    <!-- 
                        Each tablebody is a group of child specs for parent specs. 
                        Each table row is a specification with the following schema
                        td(1) - is the spec name
                        td(2 or 3) is the spec value for the car model 2 or 3 ( maxium 3 models on desktop 2 on mobile )
                        -->
                    <!-- Accordeon - card01 - Table -->
                    <table class="table table-borderless calculator specs-rows">
                        ${ populateRows(category) }
                    </table>
                </div>
            </div>
        </div>`;
}


/**
 *  This function populate dynamically the radios buttons of the modal select with al versions for the actual car
 */
export function pupulateModalSelectVersions(versions){
    let optionsContainer = $("#modal-select").find('.options-container');
    
    // Empty preloaded data from server.
    $(optionsContainer).empty();
    
    let getCheckBox = (version) => `
    <div class="grey-border-bottom">
        <label class="checkbox-container">
            <input type="radio" name="version" class="stat-checkbox" data-dtm="compare versions:add vehicle" value="${version.id}"> ${version.name}
            <span class="checkmark"></span>
        </label>
    </div>
    `;
  
    versions.forEach( version => {
        $(optionsContainer).append( getCheckBox(version) )
    })

    addColumns(versions);

    initSearch();
}

export function addselectedVersionToCompare ( selectedVersion, onColumn ){
    let carsData =  JSON.parse( $("body").attr('data-cars'));
    let cardata = carsData[selectedVersion];
    addNewCarToColumn( onColumn, cardata );
}

function addColumns(versions) {
    var buttons = '<div class="nav-item hide-mobile"></div>';
    var jellys = '<div class="col hide-mobile"></div>';

    versions.forEach((version, index) => {
        buttons += `
        <button data-column="${index + 1}" class="btn-add-to-compare nav-item nav-link align-content-center${index > 1 ? ' d-none d-md-flex': ''}">
            <div class="flex-fill">
                <span class="stat-button-link" data-dtm="compare versions">AGREGAR VERSIÓN PARA COMPARAR</span>
                <svg width="18px" height="18px" viewBox="0 0 19.71 19.71">
                    <path style="fill: #ffcf40;"
                        d="M9.85 19.72a9.86 9.86 0 1 1 9.86-9.86 9.86 9.86 0 0 1-9.86 9.86zM15.6 9.04a.83.83 0 0 0-.82-.82h-3.29V4.93a.83.83 0 0 0-.82-.82H9.03a.83.83 0 0 0-.82.82v3.31H4.92a.83.83 0 0 0-.82.82v1.64a.83.83 0 0 0 .82.82h3.29v3.29a.83.83 0 0 0 .82.82h1.63a.83.83 0 0 0 .82-.82v-3.29h3.29a.83.83 0 0 0 .82-.82V9.04z">
                    </path>
                </svg>
            </div>
        </button>
        `;
        jellys += `<div class="col car-${index + 1}${index > 1 ? ' d-none d-md-block': ''}"></div>`;
    });
    $('#cars-header-data .nav').html(buttons);
    $('#cars-header-images').html(jellys);
}


function addNewCarToColumn( columnReference, car ){
    let tableSchema = JSON.parse( $("body").attr('data-table-schema'));

    $('#specsGroups').show();
    
    // Populate column header ( image / price )
    var tableHeaderImages = $("#cars-header-images");
    var imgHTML = `<img class="menu-img" alt="LT FWD" src="${car.image}">`;
    console.log(car);
    let model = window.location.hash.replace("#", "").replace('_', ' ').toLowerCase();
    if(typeof car.CTA !== 'undefined')
        imgHTML += `<a href="${car.CTA.url}" class="cta stat-button-link" data-dtm="compare versions:` + model + ' ' + car.version.toLowerCase() + `" target="_BLANK">Conocé más</a>`;
    $(tableHeaderImages).find(`.car-${columnReference}`).empty().append(imgHTML);
 
    if($("body").attr('data-show-price') == 0) {
        car.formated_price = '';
    } else {
        car.formated_price = 'DESDE ' + car.formated_price;
    }

    // For table Header. Second, insert the version and price of the model.
    var tableHeaderVersionName = $("#cars-header-data");
    var versionPriceHTML = `
    <button data-column="${columnReference}" class="nav-item filled-car-model btn-add-to-compare btn-add-to-compare nav-item nav-link align-content-center flex-wrap stat-button-link${parseInt(columnReference) > 2 ? ' d-none d-md-flex' : ''}" data-dtm="compare versions" >
        <span>
            <span class="version">${car.version}</span><br>
            <span class="price">${car.formated_price}</span>
        </span>
        <svg width="18px" height="18px" viewBox="0 0 19.71 19.71">
            <path style="fill: #ffcf40;" d="M9.85 19.72a9.86 9.86 0 1 1 9.86-9.86 9.86 9.86 0 0 1-9.86 9.86zM15.6 9.04a.83.83 0 0 0-.82-.82h-3.29V4.93a.83.83 0 0 0-.82-.82H9.03a.83.83 0 0 0-.82.82v3.31H4.92a.83.83 0 0 0-.82.82v1.64a.83.83 0 0 0 .82.82h3.29v3.29a.83.83 0 0 0 .82.82h1.63a.83.83 0 0 0 .82-.82v-3.29h3.29a.83.83 0 0 0 .82-.82V9.04z">
            </path>
        </svg>
    </button>
    `;
    $("#cars-header-data").find(`button[data-column=${columnReference}]`).replaceWith( $(versionPriceHTML));
    
    $('#modal-select').modal('toggle');
    
    // Pouplate table for each parent category with their children categories and the values of the version selected
    // to compare
    for (var category in tableSchema) {
        populateSingleColumn( category, car[category], columnReference);
    }
    // Close modal
}

/**
 *  Return the html for each group of specs. And populate the version preselected. ( cheapier version )
 */
function populateSingleColumn( category, specs, columnReference ){
    
    var populateRows = (parentCategory )=>{

        // Find DOM element wich contain a class name with the iterated parentCategory


        let rows = "";
       
        for (var subCategory in specs) {
            if (specs.hasOwnProperty(subCategory)) {
                let specName = subCategory;
                let specValue = specs[subCategory];
                
                // Find DOM element to populate based on the parent category of the spec.
                if( $(`#collapse-${parentCategory.replace(/\s+/g, '-') } table tbody`).length > 0 ){
                    let specRows = $(`#collapse-${parentCategory.replace(/\s+/g, '-')} table tbody`);
                    
                    // Find into the row the TD according to the refference column
                    specRows.each( ( key, row ) => {
                        let TDs = $(row).find("td");
                        if( specName  == $(TDs[0]).text() ){
                            // Some specs value need an Icon.
                            let icon = getIcon(specValue);
                            if( icon ){
                                $(TDs[columnReference]).empty().append(icon)
                            }else{
                                $(TDs[columnReference]).text(specValue)
                            }
                        }
                    })
                }
    
            }
        }
        
        return rows;
    }

    populateRows(category)


}

function initSearch() {
    var markInstance = new Mark(document.querySelector("#specsGroups"));
    var keywordInput = document.querySelector("input[name='keyword']");
    var form = document.querySelector("form#search");

    function performMark(cbSuccess, cbError) {
        var keyword = keywordInput.value;

        if(!$('#specsGroups').is(':visible') || keyword.trim() == '') {
            $('.results').html('');
            return false;
        }

        if(typeof cbSuccess !== 'function') {
            var cbSuccess = function() {
                $('.results').html('');
            }
        }

        markInstance.unmark({
            done: function () {
                markInstance.mark(keyword, {
                    debug: true,
                    className: 'highlight',
                    filter: function(node, term, totalCounter) {
                        cbSuccess(node, term, totalCounter);
                        return true;
                    },
                    noMatch: function(term) {
                        if(typeof cbError == 'function')
                            cbError();
                    },
                    done: function(totalCounter) {
                        $('.results').html((totalCounter == 0 ? 'No se encontraron resultados.' : totalCounter == 1 ? 'Se encontró 1 resultado.' : 'Se encontraron ' + totalCounter + ' resultados.'))
                    }
                });
            }
        });
    };

    function showResults(e) {
        e.preventDefault();

        $('.card .collapse').collapse('hide');

        var onSuccess = function(node, term, totalCounter) {
            let button = $(node).closest('.card .collapse:not(.show)');
            
            $(node).closest('.card').find('.collapse').on('shown.bs.collapse', function() {
                if(totalCounter == 0 && typeof button !== 'undefined' && $('body').width() <= 600) {
                    $("html, body").animate({scrollTop: $(node).closest('.card').find('.collapse').offset().top - 38 }, 600);
                }
            });

            button.collapse('show');
        }

        var onError = function() {
            $('.results').html('No se encontraron resultados.');
        }
        
        setTimeout(function(){
            performMark(onSuccess, onError);
        }, 500)
        
    }

    // Listen to input and option changes
    keywordInput.addEventListener("input", performMark);
    form.addEventListener("submit", showResults);
}